import { render, staticRenderFns } from "./FileOptions.vue?vue&type=template&id=5577994a&scoped=true"
import script from "./FileOptions.vue?vue&type=script&lang=ts"
export * from "./FileOptions.vue?vue&type=script&lang=ts"
import style0 from "./FileOptions.vue?vue&type=style&index=0&id=5577994a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5577994a",
  null
  
)

export default component.exports